import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = () => {
    return (
        <div className="details skltn-lotterycard">
            <Skeleton animation="wave" width={40+'%'} height={490} />
            <Skeleton animation="wave" width={59+'%'} height={490} />
        </div>
    );
}

export default Skltn;